// extracted by mini-css-extract-plugin
export default {"wrap":"ParticipantsCount_wrap__2FR3e","count":"ParticipantsCount_count__YEdZS","label":"ParticipantsCount_label__ITh5s"};